import { Box, Stack, styled, Typography } from '@mui/material';
import { FC } from 'react';
import { CSSProperties } from '@mui/material/styles/createMixins';

interface Props {
    imageUrl: string;
    title: string;
    subtitle: string;
    style?: CSSProperties;
    borderColor?: string;
}

const BadgeWrap = styled(Stack)(() => ({
    padding: '8px 18px 8px 8px',
    borderRadius: '10px',
    alignItems: 'center',
    minWidth: '162px',
}));

export const IconTextBadge: FC<Props> = ({ imageUrl, title, subtitle, style, borderColor }) => (
    <BadgeWrap style={{ border: `1px solid ${borderColor ?? '#fff'}`, ...style }} direction="row" gap="8px">
        <Box width={40} height={40}>
            <img src={imageUrl} alt={title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </Box>
        <Stack sx={{ width: 'calc(100% - 48px)' }} gap={0}>
            <Typography color="#fff" whiteSpace="nowrap" sx={{ fontSize: '22px', fontWeight: 500 }}>
                {title}
            </Typography>
            <Typography color="#fff" whiteSpace="nowrap" sx={{ fontSize: '11px', fontWeight: 300 }}>
                {subtitle}
            </Typography>
        </Stack>
    </BadgeWrap>
);
